import { render, staticRenderFns } from "./AuditListHasFailedDeficiencies.vue?vue&type=template&id=389c4882&"
import script from "./AuditListHasFailedDeficiencies.vue?vue&type=script&lang=js&"
export * from "./AuditListHasFailedDeficiencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports